import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Alerta ao dono (vendedor) de que seu produto foi removido após uma denúncia.
 * O subject é o próprio destinatário (User); o nome do produto vem de content().
 * Leva a "Meus produtos", já que o produto foi desativado da loja.
 */
export default class ProductRemovedNotification extends Notification {
  icon() {
    return 'fas fa-ban';
  }
  href() {
    return app.route('marketplace.my_products');
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.product_removed', {
      product: data.product_name
    });
  }
  excerpt() {
    const data = this.attrs.notification.content() ?? {};
    return data.product_name ?? '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/ProductRemovedNotification', ProductRemovedNotification);